WebFont.load({
  google: {
    families: [
      'Montserrat:300,500',
      'Open Sans',
      'Zen Kaku Gothic New:400,500,700',
      'Zen Old Mincho:400,500,600'
    ]
  }
});
